import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { groupBy } from "lodash";

import { CommonService } from "src/app/Service/Common.service";
import { Module } from "src/app/Service/element-details.data.service";
import { MemberElementDetailLinkService } from "src/app/Service/member-element-detail-link/member-element-detail-link.service";
import { ExternalMemberService } from "src/app/Service/member/external-member.service";
import { NotificationService } from "src/app/Service/notification.service";
import { ProjectInfoService } from "src/app/Service/project-info/project-info.service";
import { ScheduleDocumentService } from "src/app/Service/scheduledocument/scheduleDocument.service";
import { WorkflowTemplateService } from "src/app/Service/workflow-template/workflow-template.service";
import { IProjectMemberViewModel } from "src/app/ViewModel/MembersModel";
import { IProjectElementDetailsOutput } from "src/app/ViewModel/ProjectElementsModel";
import { StandardOutputModel } from "src/app/ViewModel/StandardOutputModel";
import { WorkflowAssignedToModel } from "src/app/ViewModel/WorkflowAssignedToModel";


interface IWorkflowStepRoleMembers {
    roleId: number;
    roleDescription: string;
    roleMembers: IWorkflowMember[];
    selectedMemberIds: number[];
}

interface IWorkflowStepAssignedToMembers{
    Description:string;
    Members:IProjectMemberViewModel[],
    selectedMembersIds: number[];
}

interface IWorkflowMember {
    memberId: number;
    memberName: string;
}

@Component({
    selector: 'app-wft-action-assignedto',
    templateUrl: './wft-action-assignto.component.html',
    styleUrls: ['./wft-action-assignto.component.css']
})
export class WFActionAssignedToComponent implements OnInit {
    title:string;
    projectId: number;
    groupId: number;
    nextStepDescription: string = '';
    documentNo: string = '';
    workflowRoleMember: any[] = [];
    projectSelectedMembers: any[] = [];
    discipline: IProjectElementDetailsOutput[] = [];
    roleMembers: IWorkflowStepRoleMembers[] = [];
    members: IWorkflowStepAssignedToMembers[] = [];
    selectedRoleMembers: Map<number, number[]> = new Map<number, number[]>();
    updatedRoleMembers: any[] = [];
    loggedInMemberId: number;
    disable: boolean = true;
    isInitialNoMemberSelected!: boolean;
    isInitialNoMemberSelectedAndSubmit!: boolean;
    completedMembers!:number[];
    selectedStepMembers!:number[];

    constructor(public dialogRef: MatDialogRef<WFActionAssignedToComponent>, @Inject(MAT_DIALOG_DATA) private _data: any, public _workflowTemplateService: WorkflowTemplateService,
        private _projInfoService: ProjectInfoService, public _notificationService: NotificationService,
        public memberElementDetailLinkService: MemberElementDetailLinkService, private _commonService: CommonService,private _scheduleDocumentService: ScheduleDocumentService,private _memberService:ExternalMemberService) {
        this.getDispline();
        this.projectId = this._commonService.getProjectId();
        this.groupId = this._commonService.getLoggedInUserGroupId();
        this.loggedInMemberId = this._commonService.getLoggedInUserId();
        this.getpopup()
    }

    ngOnInit(): void {
        this.isInitialNoMemberSelected = true;
        this.isInitialNoMemberSelectedAndSubmit = true;
    }

    async getpopup() {
        if (!!this._data) {
            this.title = this._data.title != null ? this._data.title : 'Next Step Member Assignment';
            this.documentNo = this._data.docNo;
            this.nextStepDescription = this._data.nextStep.workflow_Status_Description;
            let assignedToRoles: WorkflowAssignedToModel[] = this._data.assignedToRoles;
            let assignedToMembers:WorkflowAssignedToModel[] = this._data.assignedToMembers;
            if (!!assignedToRoles && assignedToRoles.length > 0) {
                for (let i = 0; i < assignedToRoles['length']; i++) {
                    let _nextStepRoleUsers: any[] = [];
                    let _workflowRoleMember: any[] = [];
                    this._workflowTemplateService.getWorkflowMemberByRole([{ docId: this._data.docId, roleId: assignedToRoles[i].role_Id }]).subscribe((output: any) => {
                        if (output.length == 0) {
                            _nextStepRoleUsers.push({ 'docId': this._data.docId, 'memberId': 0, 'roleId': assignedToRoles[i].role_Id });
                            this.isInitialNoMemberSelected = false;
                            this.isInitialNoMemberSelectedAndSubmit = false;
                        }
                        else
                            _nextStepRoleUsers.push({ 'docId': this._data.docId, 'memberId': Object.keys(output).map(function (k) { return output[k].memberId }).join(","), 'roleId': assignedToRoles[i].role_Id });

                        let grpRoleMembersList = groupBy(_nextStepRoleUsers, 'roleId');
                        for (let roleId in grpRoleMembersList) {
                            let memberIds: number[] = grpRoleMembersList[roleId].map(x => x.memberId).toString().split(',').map(Number);
                            _workflowRoleMember.push({ roleId: Number(roleId), memberIds: memberIds });
                        }

                        for (let j = 0; j < _workflowRoleMember['length']; j++) {
                            if (assignedToRoles[i].assign_Type == 1)
                                this.getDispline_base_Member(_workflowRoleMember[j], assignedToRoles);
                        }
                    });
                }
                if(!!this._data.docTaskId)
                {
                    this._scheduleDocumentService.getWorkflowHistory(this._data.docId,this._data.docTaskId).subscribe((res:any)=>{
                        if(!!res)
                        {
                            
                            let completedMembers=res && res.length > 0 ? res[0].actionTakenMembers.split(','):'';
                            this.completedMembers=completedMembers.map(x => parseInt(x));
                        }
                    })
                }
                /*
                assignedToRoles.forEach(x => {
                    nextStepRoleUsers.push(this._workflowTemplateService.getWorkflowMemberByRole({ docId: this._data.docId, roleId: x.role_Id }));
                });
                forkJoin(nextStepRoleUsers).subscribe((res: any[]) => {
                    res.forEach((result: any[]) => {
                        let grpRoleMembersList = groupBy(result, 'roleId')
                        for (let roleId in grpRoleMembersList) {
                            let memberIds: number[] = grpRoleMembersList[roleId].map(x => x.memberId);
                            this.workflowRoleMember.push({ roleId: Number(roleId), memberIds: memberIds });
                        }
                    })
                    this.workflowRoleMember.forEach(x => {
                        this.getDispline_base_Member(x, assignedToRoles);
                    })
                })
                */
            }
            if(!!assignedToMembers && assignedToMembers.length>0)
            {
                let selectedMembers=assignedToMembers.map(x => x.member_Id);
                this.selectedStepMembers = selectedMembers;
                this._memberService.GetMembersListAgainstProject({ group_Id: this.groupId, project_Id: this.projectId }).toPromise().then(res => {
                    this.members.push({Members:res,selectedMembersIds:selectedMembers,Description: "AssignToMember"});
                });
                this.isInitialNoMemberSelectedAndSubmit = false;
            }
        }
    }

    async getDispline_base_Member(x: any, AssignedToRoles: any) {
        //Assigned To only
        let roleDescription = AssignedToRoles.filter((y: any) => y.assign_Type == 1 && y.role_Id == x.roleId)[0].role_Description;
        let assignType = AssignedToRoles.filter((y: any) => y.assign_Type == 1 && y.role_Id == x.roleId)[0].assign_Type;
        let assignTypeName = parseInt(assignType) == 1 ? " (Assigned To)" : " (Assigned CC)";
        roleDescription = roleDescription + assignTypeName;

        this.projectSelectedMembers = await this.memberElementDetailLinkService.getSelectedMembers(this.projectId, this._commonService.getLoggedInUserGroupId(), this._data.docDisciplineDEId, this._data.docDiscipline, Module.ScheduleDocument).toPromise();

        const res: any = await this._projInfoService.getProjectMembersByRole({ projectId: this.projectId, groupId: this.groupId, roleId: x.roleId }).toPromise();
        if (this.projectSelectedMembers.length != 0) {
            let Discipline_base_Member = res.filter((data: any) => {
                return this.projectSelectedMembers.some(member => data.memberId == member.memberId);
            })
            if (Discipline_base_Member != 0) {
                this.roleMembers.push({ roleId: x.roleId, selectedMemberIds: x.memberIds, roleMembers: Discipline_base_Member, roleDescription: roleDescription });
            } else {
                this.roleMembers.push({ roleId: x.roleId, selectedMemberIds: x.memberIds, roleMembers: res, roleDescription: roleDescription });
            }
            if(this.completedMembers && this.completedMembers.length>0)
            {
                this.roleMembers.filter(role => role.roleId==x.roleId)[0].selectedMemberIds=this.roleMembers.filter(role => role.roleId==x.roleId)[0].selectedMemberIds.filter(ele => this.completedMembers.indexOf(ele) < 0);
                this.roleMembers.filter(role => role.roleId==x.roleId)[0].roleMembers=this.roleMembers.filter(role => role.roleId==x.roleId)[0].roleMembers.filter(ele => this.completedMembers.indexOf(ele.memberId) < 0)
            }
        }
        else {
            this.roleMembers.push({ roleId: x.roleId, selectedMemberIds: x.memberIds, roleMembers: res, roleDescription: roleDescription });
        }
    }

    getDispline() {
        this._projInfoService.getProjectElementDetails({ projectId: this._commonService.getProjectId(), groupId: this.groupId, moduleId: Module.ScheduleDocument, deDescription: 'Discipline' })
            .subscribe({
                next: (res: IProjectElementDetailsOutput[]) => {
                    this.discipline = res;
                }, error: () => { }
            });
    }

    onChange_Member(event: any, roleId: number) {
        if (!!event) {
            if (this.selectedRoleMembers.has(roleId))
                this.selectedRoleMembers.delete(roleId);
            let selectedMemberIds: number[] = event.emittingList.map((x: { value: any; }) => x.value);
            if (selectedMemberIds.length > 0)
                this.selectedRoleMembers.set(roleId, selectedMemberIds);
        }
        if (this.selectedRoleMembers.size > 0 && !this.isInitialNoMemberSelected)
            this.disable = false;
        else
            this.disable = true;

        this.isInitialNoMemberSelected = false;
    }

    closeDialog(input: any) {
        if (input == "-1") {
            //other Discipline SH removal for B&f
            if(this._data.is_multi_disciplie_sh)
            {
                this.dialogRef.close({"successCode":200,"successMessage":""});
                return;
            }
            //end
             if ( this.selectedRoleMembers.size <= 0 &&(!this.selectedStepMembers|| this.selectedStepMembers.length <= 0)) {
                this._notificationService.showToast("Please select next step member and do 'Submit'", "Warning");
                return;
            }

            if (!this.isInitialNoMemberSelectedAndSubmit) {
                this._notificationService.showToast("Please do 'Submit' to set next step member", "Warning");
                return;
            }
        }

        if(!this._data.isReassign)
        {
            let reqData: any = {
                projectId: this._commonService.getProjectId(),
                groupId: this.groupId,
                documentId: this._data.docId,
                documentRevision: this._data.revisionNo,
                workflowId: this._data.nextStep.workflow_Id,
                createdBy: this.loggedInMemberId
            };
            this._workflowTemplateService.SendMailOnActionCompletion(reqData).subscribe((res: StandardOutputModel) => {
                this.dialogRef.close(input);
            })
        }
        else
        this.dialogRef.close(input);
    }

    changeUser() {
        if ((this.selectedRoleMembers && this.selectedRoleMembers.size > 0) || (this.selectedStepMembers && this.selectedStepMembers.length>0)) {
            this.updatedRoleMembers = [];
            if(this.selectedRoleMembers && this.selectedRoleMembers.size>0)
            {
                this.selectedRoleMembers.forEach((memberIds, roleId) => {
                    memberIds.forEach(memberId => {
                        this.updatedRoleMembers.push({ roleId: roleId, memberId: memberId });
                    })
                });
            }
        
            if(this.selectedStepMembers && this.selectedStepMembers.length>0)
            {
                this.selectedStepMembers.forEach(x => {
                    this.updatedRoleMembers.push({ roleId: null, memberId: x })
                })
            }
            let reqData: any = {
                projectId: this._commonService.getProjectId(),
                groupId: this.groupId,
                docId: this._data.docId,
                revisionNo: this._data.revisionNo,
                userId: this._commonService.getLoggedInUserId(),
                roleMembers: this.updatedRoleMembers
            };
            this._workflowTemplateService.updateWFAssignedToRoleUser(reqData).subscribe((res: StandardOutputModel) => {
                this.isInitialNoMemberSelectedAndSubmit = true;
                this.closeDialog(res);
            })
        }
        else {
            this.closeDialog("-1");
        }
    }

    onChange_Members(event:any)
    {
        if (!!event) {
            let selectedMemberIds: number[] = event.emittingList.map((x: { value: any; }) => x.value);
            this.selectedStepMembers=selectedMemberIds;
        }

        if (this.selectedStepMembers.length > 0 && !this.isInitialNoMemberSelected)
            this.disable = false;
        else
            this.disable = true;

        this.isInitialNoMemberSelected = false;
    }
}